import React from 'react'
import styled, { keyframes } from 'styled-components'

const smooth1 = keyframes`
    0% {
        d: path("M84.5 98C24.1655 98 1.52588e-05 61 0 0H355C355.833 38.4025 166 98 84.5 98Z");
    }

    25% {
        d: path("M177 117C116.666 117 1.52588e-05 61 0 0H355C355.833 38.4025 258.5 117 177 117Z");
    }
    50% {
        d: path("M253.5 97C193.166 97 1.52588e-05 61 0 0H355C355.833 38.4025 335 97 253.5 97Z");
    }
    75% {
        d: path("M167 99C106.666 99 1.52588e-05 61 0 0H355C355.833 38.4025 248.5 99 167 99Z");
    }
    100% {
        d: path("M86 99.5C25.6655 99.5 1.52588e-05 61 0 0H355C355.833 38.4025 167.5 99.5 86 99.5Z");
    }
    }
`

const smooth2 = keyframes`
    0% {
        d: path("M167 99C106.666 99 1.52588e-05 61 0 0H355C355.833 38.4025 248.5 99 167 99Z");
    }

    25% {
        d: path("M84.5 98C24.1655 98 1.52588e-05 61 0 0H355C355.833 38.4025 166 98 84.5 98Z");
    }
    50% {
        d: path("M177 117C116.666 117 1.52588e-05 61 0 0H355C355.833 38.4025 258.5 117 177 117Z");
    }
    75% {
        d: path("M253.5 97C193.166 97 1.52588e-05 61 0 0H355C355.833 38.4025 335 97 253.5 97Z");
    }
    100% {
        d: path("M86 99.5C25.6655 99.5 1.52588e-05 61 0 0H355C355.833 38.4025 167.5 99.5 86 99.5Z");
    }
    }
`

const bubblesConfig = {
  top: {
    firstBubble: {
      desktop: {
        width: 200,
        height: 60,
        left: 0,
        opaque: false,
        fill: '#05DA34',
      },
      mobile: {
        width: 140,
        height: 45,
        left: 0,
        opaque: false,
        fill: '#05DA34',
      },
    },
    secondBubble: {
      desktop: {
        width: 220,
        height: 80,
        left: 64,
        opaque: true,
        fill: '#15BEFF',
      },
      mobile: {
        width: 160,
        height: 55,
        left: 64,
        opaque: true,
        fill: '#15BEFF',
      },
    },
    invert: false,
    align: 'horizontal',
  },
  left: {
    firstBubble: {
      desktop: {
        width: 180,
        height: 120,
        left: -32,
        opaque: false,
        fill: '#05DA34',
      },
      mobile: {
        width: 200,
        height: 120,
        left: 0,
        opaque: true,
        fill: '#15BEFF',
      },
    },
    secondBubble: {
      desktop: {
        width: 200,
        height: 100,
        left: 32,
        opaque: true,
        fill: '#15BEFF',
      },
      mobile: {
        width: 150,
        height: 90,
        left: 32,
        opaque: false,
        fill: '#05DA34',
      },
    },
    invert: true,
    align: 'vertical',
  },
  right: {
    firstBubble: {
      desktop: {
        width: 200,
        height: 100,
        left: -32,
        opaque: false,
        fill: '#05DA34',
      },
      mobile: {
        width: 200,
        height: 70,
        left: 0,
        opaque: false,
        fill: '#05DA34',
      },
    },
    secondBubble: {
      desktop: {
        width: 210,
        height: 120,
        left: 32,
        opaque: true,
        fill: '#15BEFF',
      },
      mobile: {
        width: 180,
        height: 70,
        left: 32,
        opaque: true,
        fill: '#15BEFF',
      },
    },
    invert: false,
    align: 'vertical',
  },
}

const Container = styled.div`
  position: relative;
  z-index: -2;
  transform: ${props =>
    props.align === 'horizontal' ? 'rotate(0deg)' : 'rotate(90deg)'};
`

const Bubble = styled.svg`
  position: absolute;
  transform: ${props => (props.invert ? 'matrix(1, 0, 0, -1, 0, 0)' : '')};
  display: inline-block;
  width: ${props => `${props.bubble.desktop.width}px`};
  height: ${props => `${props.bubble.desktop.height}px`};
  left: ${props => `${props.bubble.desktop.left}px`};

  path {
    fill: ${props => props.bubble.desktop.fill};
    animation: ${props => props.animation} 15s linear infinite alternate;
    opacity: ${props => (props.bubble.desktop.opaque ? 0.4 : 0.6)};
  }

  @media screen and (max-width: 768px) {
    width: ${props => `${props.bubble.mobile.width}px`};
    height: ${props => `${props.bubble.mobile.height}px`};
    left: ${props => `${props.bubble.mobile.left}px`};

    path {
      fill: ${props => props.bubble.mobile.fill};
      animation: ${props => props.animation} 15s linear infinite alternate;
      opacity: ${props => (props.bubble.mobile.opaque ? 0.6 : 0.8)};
    }
  }
`

const Bubbles = ({ position }) => {
  const config = bubblesConfig[position]

  const { firstBubble, secondBubble, align, invert } = config

  return (
    <Container align={align}>
      <Bubble
        bubble={firstBubble}
        preserveAspectRatio="none"
        animation={smooth2}
        invert={invert}
        viewBox="0 0 356 118"
      >
        <path />
      </Bubble>
      <Bubble
        bubble={secondBubble}
        preserveAspectRatio="none"
        animation={smooth1}
        invert={invert}
        viewBox="0 0 356 118"
      >
        <path />
      </Bubble>
    </Container>
  )
}

export default Bubbles
